
const DotIcon = () => {
	return (
		<svg
			enableBackground="new 0 0 122.88 122.88"
			fill="currentColor"
			height="0.65em"
			id="Layer_1"
			version="1.1"
			viewBox="0 0 122.88 122.88"
			width="0.65em"
			x="0px"
			xmlns="http://www.w3.org/2000/svg"
			y="0px"
		>
			<g>
				<path
					clipRule="evenodd"
					d="M61.438,0c33.93,0,61.441,27.512,61.441,61.441 c0,33.929-27.512,61.438-61.441,61.438C27.512,122.88,0,95.37,0,61.441C0,27.512,27.512,0,61.438,0L61.438,0z"
					fillRule="evenodd"
				/>
			</g>
		</svg>
	);
};

export default DotIcon;
